import React from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useTranslation } from 'react-i18next'
import { useNavigate, useParams } from 'react-router-dom'

import { AllowanceCharges } from '../features/invoice/components/AllowanceCharges'
import { Attachment } from '../features/invoice/components/Attachment'
import { Header } from '../features/invoice/components/Header'
import { DataHandlingInvoiceData } from '../features/invoice/components/InvoiceData'
import { InvoiceItems } from '../features/invoice/components/InvoiceItems'
import { OrderInformation } from '../features/invoice/components/OrderInformation'
import { DataHandlingSummary } from '../features/invoice/components/Summary'
import { TermsOfPayments } from '../features/invoice/components/TermsOfPayments'
import { Title } from '../features/invoice/components/Title'
import { InvoiceMessageContextProvider } from '../features/invoice/contexts/messages'
import { useInvoiceById } from '../features/invoice/data'
import FallbackErrorMessage from '../utils/errors/FallbackMessage'

export const InvoicePage: React.FC = () => {
  const { t } = useTranslation()
  const { id } = useParams()
  const { data, error, isLoading } = useInvoiceById(id as string)
  const navigate = useNavigate()

  if (error) {
    return (
      <>
        <div className="flex justify-content-between flex-wrap mb-5">
          <div className="flex justify-content-start flex-wrap">
            <div className="cursor-pointer mr-2" onClick={() => navigate('/')}>
              <i className="pi pi-angle-left text-primary text-5xl"></i>
            </div>
            <div className="font-normal text-4xl">
              {t('common.errors.noData')}
            </div>
          </div>
        </div>
      </>
    )
  }

  if (isLoading) {
    return null
  }
  return (
    <>
      <ErrorBoundary FallbackComponent={FallbackErrorMessage}>
        <Title invoiceId={data?.Id as string} />
        <InvoiceMessageContextProvider>
          <Header invoiceId={data?.Id as string} />

          <OrderInformation invoiceId={data?.Id as string} />

          <DataHandlingInvoiceData invoiceId={data?.Id as string} />

          <AllowanceCharges invoiceId={data?.Id as string} />

          <InvoiceItems invoiceId={data?.Id as string} />

          <DataHandlingSummary invoiceId={data?.Id as string} />

          <TermsOfPayments invoiceId={data?.Id as string} />

          <Attachment
            invoiceId={data?.Id as string}
            processId={data?.ProcessId as string}
          />
        </InvoiceMessageContextProvider>
      </ErrorBoundary>
    </>
  )
}
